export interface Product {
  id: string;
  title: string;
  price: string;
  image: string;
  url: string;
  category: string;
}

export interface ProductCategory {
  key: string;
  name: string;
  products: Product[];
}

export const productCategories: ProductCategory[] = [
  {
    key: 'shoes',
    name: 'Shoes',
    products: [
      {
        id: '136312',
        title: 'Black Canvas Combat Boots with Side Zippers and Lace-Up Design',
        price: '\u00a5678 \u2248 $94.17',
        image: 'https://si.geilicdn.com/open1775823299-1234478995-52da00000198bbc54c190aa0c791_620_620.jpg',
        url: 'https://kaspreadsheet.com/goods-136312.html',
        category: 'Shoes',
      },
      {
        id: '136311',
        title: 'Louis Vuitton Archlight White Monogram Print Sneakers',
        price: '\u00a5397 \u2248 $55.14',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-6f9600000194e2901d1a0a239383_800_600.jpg',
        url: 'https://kaspreadsheet.com/goods-136311.html',
        category: 'Shoes',
      },
      {
        id: '136310',
        title: 'Rick Owens Geobasket High-Top Sneaker Black White Contrast Toe',
        price: '\u00a5585 \u2248 $81.25',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-1a000000019749d603be0a22d249_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-136310.html',
        category: 'Shoes',
      },
      {
        id: '136309',
        title: 'Off-White Diagonal Arrow Low-Top Sneakers - White/Black',
        price: '\u00a5300 \u2248 $41.67',
        image: 'https://si.geilicdn.com/pcitem1513127982-3b200000019667fbebea0a21146b_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-136309.html',
        category: 'Shoes',
      },
      {
        id: '136308',
        title: 'Nike Tiempo Legend 9 IC Indoor Court Soccer Shoes - Multicolor',
        price: '\u00a5268 \u2248 $37.22',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-6f9000000194b81466ec0aa08290_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-136308.html',
        category: 'Shoes',
      },
      {
        id: '136307',
        title: 'Louis Vuitton Archlight Star Motif Sneaker - Beige Snake Print',
        price: '\u00a5528 \u2248 $73.33',
        image: 'https://si.geilicdn.com/pcitem1871933355-69ef00000190a56ff3d40a8133cc_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-136307.html',
        category: 'Shoes',
      },
      {
        id: '136306',
        title: 'Louis Vuitton Trainer Low Monogram Canvas Sneaker Red White',
        price: '\u00a5297 \u2248 $41.25',
        image: 'https://si.geilicdn.com/wdseller901862032983-53ff00000190603e9a530a2102c5_1170_1173.jpg',
        url: 'https://kaspreadsheet.com/goods-136306.html',
        category: 'Shoes',
      },
      {
        id: '136305',
        title: 'Off-White Diagonal Arrow Low-Top Sneakers Black-White',
        price: '\u00a5258 \u2248 $35.83',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-38cd000001977cd8cc7d0a231226_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-136305.html',
        category: 'Shoes',
      },
    ],
  },
  {
    key: 'hoodiesSweaters',
    name: 'Hoodies/Sweaters',
    products: [
      {
        id: '138084',
        title: 'OFFSETTEARS Black Hoodie with Orange Floral Graphic and Signature Print',
        price: '\u00a5186 \u2248 $25.83',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-6bc000000194965ed7d10a239383_1920_1920.jpg',
        url: 'https://kaspreadsheet.com/goods-138084.html',
        category: 'Hoodies/Sweaters',
      },
      {
        id: '137567',
        title: 'Supreme Margiela Paris 1994 Zip-Up Hoodie Skull Lining Black',
        price: '\u00a5136 \u2248 $18.89',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-4ad900000199c30f90a50aa0229a_1280_1280.jpg',
        url: 'https://kaspreadsheet.com/goods-137567.html',
        category: 'Hoodies/Sweaters',
      },
      {
        id: '137459',
        title: 'BAPE x Inter Miami CF Camo Hoodie Pink Black Gray',
        price: '\u00a5141 \u2248 $19.58',
        image: 'https://si.geilicdn.com/open1815288597-1234478995-0c480000019791690d9a0a8133b0_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-137459.html',
        category: 'Hoodies/Sweaters',
      },
      {
        id: '137449',
        title: 'Dior Oblique Monogram Logo Appliqu\u00e9 White Sweatshirt',
        price: '\u00a5176 \u2248 $24.44',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-679b00000195474e9a2d0a8115c2_1125_1125.jpg',
        url: 'https://kaspreadsheet.com/goods-137449.html',
        category: 'Hoodies/Sweaters',
      },
      {
        id: '137348',
        title: 'Nike Lost Repeat Graphic Fleece Crewneck Sweatshirt - Cream Green',
        price: '\u00a5274 \u2248 $38.06',
        image: 'https://si.geilicdn.com/pcitem1945679661-278900000198c64832cd0a20e2c5_945_1280.jpg',
        url: 'https://kaspreadsheet.com/goods-137348.html',
        category: 'Hoodies/Sweaters',
      },
      {
        id: '137303',
        title: 'BOSS Embossed Logo Crewneck Sweatshirt - Black',
        price: '\u00a5141 \u2248 $19.58',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-4dc8000001977c8963190a8133b0_1024_1024.jpg',
        url: 'https://kaspreadsheet.com/goods-137303.html',
        category: 'Hoodies/Sweaters',
      },
      {
        id: '137105',
        title: 'Polo Ralph Lauren Cable Knit Short-Sleeve Crewneck Sweater - Pink',
        price: '\u00a5148 \u2248 $20.56',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-7dfe000001955822c0a80a22d249_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-137105.html',
        category: 'Hoodies/Sweaters',
      },
      {
        id: '137044',
        title: 'Burberry Rainbow Equestrian Knight Logo White Sweatshirt',
        price: '\u00a5155 \u2248 $21.53',
        image: 'https://si.geilicdn.com/pcitem1886196013-3fe800000195989eafd90a210256_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-137044.html',
        category: 'Hoodies/Sweaters',
      },
    ],
  },
  {
    key: 'tShirts',
    name: 'T-Shirts',
    products: [
      {
        id: '138192',
        title: 'Nike Dri-FIT Cotton T-Shirt with 1972 Logo Print - Black',
        price: '\u00a5112 \u2248 $15.56',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-529a000001977c85cb740a231226_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-138192.html',
        category: 'T-Shirts',
      },
      {
        id: '138188',
        title: 'Louis Vuitton x Malletier Navy T-Shirt with White Rabbit Graphic',
        price: '\u00a5175 \u2248 $24.31',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-2e0f00000196ab5b18160a8133b0_1080_1080.jpg',
        url: 'https://kaspreadsheet.com/goods-138188.html',
        category: 'T-Shirts',
      },
      {
        id: '138187',
        title: 'St\u00fcssy World Tour Polo Shirt - White/Black with Lion & Billiard Ball',
        price: '\u00a5169 \u2248 $23.47',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-0017000001974412c93c0a23b491_1024_1024.jpg',
        url: 'https://kaspreadsheet.com/goods-138187.html',
        category: 'T-Shirts',
      },
      {
        id: '138186',
        title: 'FENDI Dragon Graphic T-Shirt Black',
        price: '\u00a5109 \u2248 $15.14',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-3868000001955b71f6390a23b491_1080_1080.jpg',
        url: 'https://kaspreadsheet.com/goods-138186.html',
        category: 'T-Shirts',
      },
      {
        id: '138185',
        title: 'Palm Angels Bear Graphic T-Shirt Black',
        price: '\u00a5139 \u2248 $19.31',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-3d10000001952f1af3560a23b491_1000_1000.jpg',
        url: 'https://kaspreadsheet.com/goods-138185.html',
        category: 'T-Shirts',
      },
      {
        id: '138183',
        title: 'Rhude Premium Cigars Logo Graphic T-Shirt Black',
        price: '\u00a598 \u2248 $13.61',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-214100000195c9825ed90a8133b0_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-138183.html',
        category: 'T-Shirts',
      },
      {
        id: '138182',
        title: 'Valentino VLogo Embroidered Black T-Shirt with Pink Logo',
        price: '\u00a5150 \u2248 $20.83',
        image: 'https://si.geilicdn.com/open1718885333-1234478995-4cd50000019648d7af310a23b491-unadjust_475_522.png',
        url: 'https://kaspreadsheet.com/goods-138182.html',
        category: 'T-Shirts',
      },
      {
        id: '138181',
        title: 'Cole Buxton Dog Logo Graphic T-Shirt Black',
        price: '\u00a5124 \u2248 $17.22',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-096700000197974c396b0a22d249_1280_1280.jpg',
        url: 'https://kaspreadsheet.com/goods-138181.html',
        category: 'T-Shirts',
      },
    ],
  },
  {
    key: 'jackets',
    name: 'Jackets',
    products: [
      {
        id: '136582',
        title: 'Under Armour Storm Rain Jacket Black with Reflective Logo',
        price: '\u00a5118 \u2248 $16.39',
        image: 'https://si.geilicdn.com/open1767724244-1234478995-69310000019715c9e1c30a8133b0_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-136582.html',
        category: 'Jackets',
      },
      {
        id: '136303',
        title: 'Louis Vuitton Monogram Print Hooded Windbreaker Jacket Black',
        price: '\u00a5472 \u2248 $65.56',
        image: 'https://si.geilicdn.com/open1742170557-1234478995-7b50000001977caa02d80a22d249_1276_1702.jpg',
        url: 'https://kaspreadsheet.com/goods-136303.html',
        category: 'Jackets',
      },
      {
        id: '136284',
        title: 'A BATHING APE Denim Jacket with Embroidered Cross Motif',
        price: '\u00a5288 \u2248 $40.00',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-7e94000001943acc82ee0a239383_1000_1000.jpg',
        url: 'https://kaspreadsheet.com/goods-136284.html',
        category: 'Jackets',
      },
      {
        id: '136276',
        title: 'Zara Butterfly Logo Fleece Track Jacket Navy Purple Stripes',
        price: '\u00a5190 \u2248 $26.39',
        image: 'https://si.geilicdn.com/open1675136579-1234478995-66aa00000198a68a28e10a231226_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-136276.html',
        category: 'Jackets',
      },
      {
        id: '136203',
        title: 'Canada Goose Crofton Vest Black Quilted Down Puffer Vest',
        price: '\u00a5329 \u2248 $45.69',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-0d9d00000194c30b210a0a210559_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-136203.html',
        category: 'Jackets',
      },
      {
        id: '136189',
        title: 'Louis Vuitton Monogram Quilted Puffer Jacket - Gray Black',
        price: '\u00a5260 \u2248 $36.11',
        image: 'https://si.geilicdn.com/pcitem901971869584-335c00000199bdf837270a23111a_1280_1280.jpg',
        url: 'https://kaspreadsheet.com/goods-136189.html',
        category: 'Jackets',
      },
      {
        id: '136181',
        title: 'Canada Goose Youth Expedition Parka - Arctic Camo with Fur Trim',
        price: '\u00a5590 \u2248 $81.94',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-4c51000001952f1d25bb0aa0834c_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-136181.html',
        category: 'Jackets',
      },
      {
        id: '135968',
        title: 'Prada RDAPA Logo Tape Track Jacket White Black',
        price: '\u00a5517 \u2248 $71.81',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-3e840000019769c4fcd30a8115c2_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-135968.html',
        category: 'Jackets',
      },
    ],
  },
  {
    key: 'pantsShorts',
    name: 'Pants/Shorts',
    products: [
      {
        id: '137495',
        title: 'OceanView Cruise Logo Shorts - Pink Cotton Blend',
        price: '\u00a594 \u2248 $13.06',
        image: 'https://si.geilicdn.com/open1877254536-1234478995-1a74000001972b942b510a8115c2_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-137495.html',
        category: 'Pants/Shorts',
      },
      {
        id: '137207',
        title: 'Prada Re-Nylon Triangle Logo Swim Shorts - Black',
        price: '\u00a5153 \u2248 $21.25',
        image: 'https://si.geilicdn.com/open1691309225-1234478995-51a700000196d91ec6a60aa0834c_2560_2560.jpg',
        url: 'https://kaspreadsheet.com/goods-137207.html',
        category: 'Pants/Shorts',
      },
      {
        id: '136530',
        title: '1230 Holy Holy Graphic Shorts - Black Mesh Side Panel',
        price: '\u00a5142 \u2248 $19.72',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-1d6c00000197494076c30a22d249-unadjust_900_900.png',
        url: 'https://kaspreadsheet.com/goods-136530.html',
        category: 'Pants/Shorts',
      },
      {
        id: '136300',
        title: 'Balenciaga Rainbow Logo Washed Light Grey Denim Jeans',
        price: '\u00a5280 \u2248 $38.89',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-78d400000196c048651b0a231226_1442_1922.jpg',
        url: 'https://kaspreadsheet.com/goods-136300.html',
        category: 'Pants/Shorts',
      },
      {
        id: '136286',
        title: 'D\u00c9PT de la GALERIE Paint-Splatter Track Pants White',
        price: '\u00a5169 \u2248 $23.47',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-606c00000193dded32260a22d234_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-136286.html',
        category: 'Pants/Shorts',
      },
      {
        id: '136266',
        title: 'Gucci GG Monogram Print Drawstring Shorts - White/Navy',
        price: '\u00a5110 \u2248 $15.28',
        image: 'https://si.geilicdn.com/open1718885333-1234478995-71b10000019648fa027e0a231226_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-136266.html',
        category: 'Pants/Shorts',
      },
      {
        id: '136257',
        title: 'Nike Run Air Force 1 Black Jogger Pants with Side Logo',
        price: '\u00a5120 \u2248 $16.67',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-70e300000196c03ef9eb0a231226_1440_1920.jpg',
        url: 'https://kaspreadsheet.com/goods-136257.html',
        category: 'Pants/Shorts',
      },
      {
        id: '136249',
        title: 'Moncler Diagonal Stripe Shorts - White with Red Accent',
        price: '\u00a5199 \u2248 $27.64',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-0e490000019558486bc90a8115c2_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-136249.html',
        category: 'Pants/Shorts',
      },
    ],
  },
  {
    key: 'headwear',
    name: 'Headwear',
    products: [
      {
        id: '133388',
        title: 'New Era 59FIFTY MLB Authentic On-Field Cap - Black LA Dodgers Palm Tree',
        price: '\u00a5170 \u2248 $23.61',
        image: 'https://si.geilicdn.com/open1821611651-1234478995-7ca3000001984ac153c70aa043f9_1137_1137.jpg',
        url: 'https://kaspreadsheet.com/goods-133388.html',
        category: 'Headwear',
      },
      {
        id: '133383',
        title: 'Burberry Logo Knit Beanie Hat - Gray with Black Band',
        price: '\u00a5112 \u2248 $15.56',
        image: 'https://si.geilicdn.com/open1815288597-1234478995-73f50000019767422ae30a22d249_1074_1074.jpg',
        url: 'https://kaspreadsheet.com/goods-133383.html',
        category: 'Headwear',
      },
      {
        id: '133370',
        title: 'alo Reflective Visor with Embossed Logo - Black Silver',
        price: '\u00a581 \u2248 $11.25',
        image: 'https://si.geilicdn.com/open1767724244-1234478995-31420000019672781d5b0a8133b0_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-133370.html',
        category: 'Headwear',
      },
      {
        id: '133369',
        title: 'Gucci GG Monogram Beige Mesh Baseball Cap with Brown Trim',
        price: '\u00a5110 \u2248 $15.28',
        image: 'https://si.geilicdn.com/open1811769437-1234478995-544b0000019764bb73ad0aa0c79f-unadjust_886_849.png',
        url: 'https://kaspreadsheet.com/goods-133369.html',
        category: 'Headwear',
      },
      {
        id: '133362',
        title: 'SYNER Graffiti Knit Beanie Hat - Neon Green/Black Contrast',
        price: '\u00a581 \u2248 $11.25',
        image: 'https://si.geilicdn.com/open1612884413-1234478995-1c6c000001977e57fb830a231226_1280_1280.jpg',
        url: 'https://kaspreadsheet.com/goods-133362.html',
        category: 'Headwear',
      },
      {
        id: '133349',
        title: 'Dior Oblique Monogram Baseball Cap Black-White Pattern',
        price: '\u00a599 \u2248 $13.75',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-6e3400000195457be2de0a231226_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-133349.html',
        category: 'Headwear',
      },
      {
        id: '133343',
        title: 'New Era 59FIFTY MLB Los Angeles Dodgers Floral Blue Cap',
        price: '\u00a599 \u2248 $13.75',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-4bc600000194e27f91c20a232357-unadjust_900_900.png',
        url: 'https://kaspreadsheet.com/goods-133343.html',
        category: 'Headwear',
      },
      {
        id: '133342',
        title: 'Stone Island Compass Logo Bucket Hat - Gray with Drawstring',
        price: '\u00a558 \u2248 $8.06',
        image: 'https://si.geilicdn.com/pcitem901908522262-348800000195413652c40a2395d6-unadjust_500_500.gif',
        url: 'https://kaspreadsheet.com/goods-133342.html',
        category: 'Headwear',
      },
    ],
  },
  {
    key: 'sets',
    name: 'Sets',
    products: [
      {
        id: '138191',
        title: 'Nike Dri-FIT Academy Soccer Jersey and Shorts Set - Black/White',
        price: '\u00a5144 \u2248 $20.00',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-15a700000197493e80b70a8133b0_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-138191.html',
        category: 'Sets',
      },
      {
        id: '138184',
        title: 'Stone Island Compass Logo Short Set - White',
        price: '\u00a5175 \u2248 $24.31',
        image: 'https://si.geilicdn.com/open1742154973-1234478995-22160000019769f3aee70aa0c79f_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-138184.html',
        category: 'Sets',
      },
      {
        id: '138178',
        title: 'Gucci GG Monogram Print Short-Sleeve Shirt and Shorts Set Beige',
        price: '\u00a5154 \u2248 $21.39',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-44260000019779312b2c0aa0c79f_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-138178.html',
        category: 'Sets',
      },
      {
        id: '138161',
        title: 'Real Madrid 2023-24 Training Kit Navy Yellow V-Neck Jersey Shorts Set',
        price: '\u00a5139 \u2248 $19.31',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-0675000001973f6663200a23b4de_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-138161.html',
        category: 'Sets',
      },
      {
        id: '138159',
        title: 'BOSS Black Track Suit with Beige Logo Stripes and Zipper Front',
        price: '\u00a5177 \u2248 $24.58',
        image: 'https://si.geilicdn.com/pcitem1944626857-760e0000019773c369f50a239846_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-138159.html',
        category: 'Sets',
      },
      {
        id: '138154',
        title: 'ALLSTAR Flame Graphic T-Shirt and Shorts Set - Black with Neon Green Flames',
        price: '\u00a5315 \u2248 $43.75',
        image: 'https://si.geilicdn.com/open1824078381-1234478995-3ab900000196a5bc0b000a8115c2_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-138154.html',
        category: 'Sets',
      },
      {
        id: '138153',
        title: 'Stone Island Compass Logo Short Set - Pink Cotton Twill',
        price: '\u00a5270 \u2248 $37.50',
        image: 'https://si.geilicdn.com/open1811769437-1234478995-0fa9000001973f4d55700a23b4de_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-138153.html',
        category: 'Sets',
      },
      {
        id: '138135',
        title: 'Versace Logo Print Short-Sleeve Shirt and Shorts Set - Navy Green Pink',
        price: '\u00a5125 \u2248 $17.36',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-53280000019572c0d6ca0a8115c2_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-138135.html',
        category: 'Sets',
      },
    ],
  },
  {
    key: 'underwear',
    name: 'Underwear/Underpants',
    products: [
      {
        id: '136447',
        title: 'Louis Vuitton Monogram Gradient Bodysuit with White Trim',
        price: '\u00a5159 \u2248 $22.08',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-416b0000019572963ee90aa08290_1440_1920.jpg',
        url: 'https://kaspreadsheet.com/goods-136447.html',
        category: 'Underwear/Underpants',
      },
      {
        id: '136200',
        title: 'lululemon Align Soft High-Waisted Underwear with Lace Trim',
        price: '\u00a595 \u2248 $13.19',
        image: 'https://si.geilicdn.com/open1718885333-1234478995-3e8000000197a64cbaec0a23b491_1080_1441.jpg',
        url: 'https://kaspreadsheet.com/goods-136200.html',
        category: 'Underwear/Underpants',
      },
      {
        id: '136037',
        title: 'Calvin Klein Men\u2019s Cotton Boxer Briefs - Gray Black Navy',
        price: '\u00a529 \u2248 $4.03',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-417800000193c49caaea0a210559_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-136037.html',
        category: 'Underwear/Underpants',
      },
      {
        id: '135612',
        title: 'LACOSTE Classic Logo Waistband Boxer Briefs 3-Pack Green White Black',
        price: '\u00a599 \u2248 $13.75',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-659b00000193ce9623d00a8133b5_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-135612.html',
        category: 'Underwear/Underpants',
      },
      {
        id: '135596',
        title: 'PSD SpongeBob SquarePants Underwear - Blue Ocean Print Boxer Briefs',
        price: '\u00a545 \u2248 $6.25',
        image: 'https://si.geilicdn.com/pcitem901950853318-589000000196dd1ae0cf0a81347d_4800_4800.jpg',
        url: 'https://kaspreadsheet.com/goods-135596.html',
        category: 'Underwear/Underpants',
      },
      {
        id: '135593',
        title: 'Calvin Klein Men\u2019s Cotton Boxer Briefs - Gray Black Navy',
        price: '\u00a5108 \u2248 $15.00',
        image: 'https://si.geilicdn.com/open1783746229-1234478995-7eae000001966daf5aca0a22d249_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-135593.html',
        category: 'Underwear/Underpants',
      },
      {
        id: '135575',
        title: 'Supreme Boxer Briefs Cotton Underwear with Logo Waistband',
        price: '\u00a530 \u2248 $4.17',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-7ffd000001974a632f450a8133b0_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-135575.html',
        category: 'Underwear/Underpants',
      },
      {
        id: '135566',
        title: 'Herm\u00e8s Logo Waistband Boxer Briefs - Black White Yellow',
        price: '\u00a534 \u2248 $4.72',
        image: 'https://si.geilicdn.com/open1858585309-1234478995-2360000001977d2fc4a40a8133b0_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-135566.html',
        category: 'Underwear/Underpants',
      },
    ],
  },
  {
    key: 'jersey',
    name: 'Jersey',
    products: [
      {
        id: '138190',
        title: 'Paris Saint-Germain 2023 Champions of Europe Jersey - Navy Blue',
        price: '\u00a5106 \u2248 $14.72',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-030c000001973f6540060aa0834c_942_983.jpg',
        url: 'https://kaspreadsheet.com/goods-138190.html',
        category: 'Jersey',
      },
      {
        id: '138180',
        title: 'PSG Qatar Airways Training Jersey - Red Blue Abstract Pattern',
        price: '\u00a5165 \u2248 $22.92',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-7a2000000195bfc0adac0a8115c2_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-138180.html',
        category: 'Jersey',
      },
      {
        id: '138175',
        title: 'FC Barcelona Lamine Yamal 19 Black Away Jersey 2024-25',
        price: '\u00a5128 \u2248 $17.78',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-025700000195cf19315b0a23b4de_450_450.jpg',
        url: 'https://kaspreadsheet.com/goods-138175.html',
        category: 'Jersey',
      },
      {
        id: '138164',
        title: 'Supreme 30th Anniversary Football Jersey - Green Diamond Pattern',
        price: '\u00a5331 \u2248 $45.97',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-1c2d000001974942961f0a23b4de_800_762.jpg',
        url: 'https://kaspreadsheet.com/goods-138164.html',
        category: 'Jersey',
      },
      {
        id: '138155',
        title: 'Palmeiras 2023 Home Jersey Yellow Green Crest',
        price: '\u00a563 \u2248 $8.75',
        image: 'https://si.geilicdn.com/open1675274933-1234478995-19cc000001967ca93aab0a23b491_1202_1202.jpg',
        url: 'https://kaspreadsheet.com/goods-138155.html',
        category: 'Jersey',
      },
      {
        id: '138150',
        title: 'Real Madrid 2000-01 Home Jersey White with Black Stripes TeKa Sponsor',
        price: '\u00a5118 \u2248 $16.39',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-66a800000195bfccb6a40a231226_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-138150.html',
        category: 'Jersey',
      },
      {
        id: '138148',
        title: 'Adidas x Flame Silhouette Football Jersey - White Black Design',
        price: '\u00a599 \u2248 $13.75',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-279000000195c9a5168f0aa08290_941_963.jpg',
        url: 'https://kaspreadsheet.com/goods-138148.html',
        category: 'Jersey',
      },
      {
        id: '138139',
        title: 'PSG 2023-24 Third Jersey Black with Red-White-Blue Vertical Stripes',
        price: '\u00a5142 \u2248 $19.72',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-7bf5000001975f2f34a10a23b4de_1107_1107.jpg',
        url: 'https://kaspreadsheet.com/goods-138139.html',
        category: 'Jersey',
      },
    ],
  },
  {
    key: 'accessories',
    name: 'Accessories',
    products: [
      {
        id: '137556',
        title: 'Cartier Santos Dumont Square Watch Blue Dial Black Leather Strap',
        price: '\u00a5599 \u2248 $83.19',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-10690000019673cee0e70aa0834c_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-137556.html',
        category: 'Accessories',
      },
      {
        id: '137382',
        title: 'Louis Vuitton Monogram World Tour Bracelet - Black Rope with Logo Discs',
        price: '\u00a5165 \u2248 $22.92',
        image: 'https://si.geilicdn.com/open1767724244-1234478995-423700000197160db1620a8133b0_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-137382.html',
        category: 'Accessories',
      },
      {
        id: '135965',
        title: 'Apple Watch Series 6 Black Aluminum Case with Black Sport Band',
        price: '\u00a5170 \u2248 $23.61',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-5ea900000193d8cce9290a232357_1024_1024.jpg',
        url: 'https://kaspreadsheet.com/goods-135965.html',
        category: 'Accessories',
      },
      {
        id: '135384',
        title: 'Apple Watch Series 9 GPS + Cellular, Black Aluminum Case with Black Sport Band',
        price: '\u00a5288 \u2248 $40.00',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-07640000019673be92750a8115c2_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-135384.html',
        category: 'Accessories',
      },
      {
        id: '135380',
        title: 'Apple Watch Ultra 2 with Purple Woven Band - GPS + Cellular',
        price: '\u00a5399 \u2248 $55.42',
        image: 'https://si.geilicdn.com/open1776978413-1234478995-0d200000019740bb8f220a8115c2_1179_1179.jpg',
        url: 'https://kaspreadsheet.com/goods-135380.html',
        category: 'Accessories',
      },
      {
        id: '134538',
        title: 'Apple Watch Ultra 2 with Desert Tan Alpine Loop Band',
        price: '\u00a5275 \u2248 $38.19',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-3047000001927ca712ba0aa08290_1290_1290.jpg',
        url: 'https://kaspreadsheet.com/goods-134538.html',
        category: 'Accessories',
      },
      {
        id: '133945',
        title: 'Casio Baby-G G-Lide BGA-210 Digital Watch - Neon Green Resin Case',
        price: '\u00a5150 \u2248 $20.83',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-4a5a000001937c768dab0a210298_1080_810.jpg',
        url: 'https://kaspreadsheet.com/goods-133945.html',
        category: 'Accessories',
      },
      {
        id: '133944',
        title: 'Apple Watch Series 7 Black Aluminum with Midnight Sport Band',
        price: '\u00a5258 \u2248 $35.83',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-0fe50000019673cd17830aa0834c_750_750.jpg',
        url: 'https://kaspreadsheet.com/goods-133944.html',
        category: 'Accessories',
      },
    ],
  },
  {
    key: 'bags',
    name: 'Bags',
    products: [
      {
        id: '135418',
        title: 'SMINDUS TRUO Black Mesh Golf Towel with Pink Logo and Globe Design',
        price: '\u00a5261 \u2248 $36.25',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-44f8000001976cf1b5d50a8115c2-unadjust_500_500.gif',
        url: 'https://kaspreadsheet.com/goods-135418.html',
        category: 'Bags',
      },
      {
        id: '134959',
        title: 'Prada Milano Woven Mini Tote Bag - Black Textured with Logo',
        price: '\u00a5335 \u2248 $46.53',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-5c300000019572da6a310a8115c2_1442_1922.jpg',
        url: 'https://kaspreadsheet.com/goods-134959.html',
        category: 'Bags',
      },
      {
        id: '133386',
        title: 'Goyard Saint Louis Mini Crossbody Bag Pink Chevron Pattern',
        price: '\u00a5165 \u2248 $22.92',
        image: 'https://si.geilicdn.com/pcitem901900035971-74aa000001938a89828e0a23041a_1000_1333.jpg',
        url: 'https://kaspreadsheet.com/goods-133386.html',
        category: 'Bags',
      },
      {
        id: '133276',
        title: 'Louis Vuitton Monogram Canvas Tote Bag Brown with Tan Leather Trim',
        price: '\u00a5139 \u2248 $19.31',
        image: 'https://si.geilicdn.com/pcitem901891552790-1ba50000019390628c620a2396f4_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-133276.html',
        category: 'Bags',
      },
      {
        id: '133272',
        title: 'Chanel 25P Kelly Mini Bag Beige Quilted Lambskin Top Handle Chain',
        price: '\u00a5374 \u2248 $51.94',
        image: 'https://si.geilicdn.com/open1823866485-1234478995-534900000195a49cb72e0a8133b0_1080_1439.jpg',
        url: 'https://kaspreadsheet.com/goods-133272.html',
        category: 'Bags',
      },
      {
        id: '133264',
        title: 'Chanel White Quilted Double Flap Bucket Bag with Gold CC Logo',
        price: '\u00a5199 \u2248 $27.64',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-74c600000195475287920a23b4de_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-133264.html',
        category: 'Bags',
      },
      {
        id: '133244',
        title: 'Goyard Saint-Louis PM Tote Bag in Green Chevron Canvas',
        price: '\u00a5138 \u2248 $19.17',
        image: 'https://si.geilicdn.com/open1757144309-1234478995-5bcc0000019698dce2c40a22d249_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-133244.html',
        category: 'Bags',
      },
      {
        id: '133226',
        title: 'Louis Vuitton Allin BB Monogram Empreinte Black Bucket Bag',
        price: '\u00a5546 \u2248 $75.83',
        image: 'https://si.geilicdn.com/ch1931865500-1a9400000197741d80650a230115_1920_1440.jpg',
        url: 'https://kaspreadsheet.com/goods-133226.html',
        category: 'Bags',
      },
    ],
  },
  {
    key: 'belts',
    name: 'Belts',
    products: [
      {
        id: '133199',
        title: 'Fendi FF Logo Belt with Gold Silver Yellow Blue Buckle',
        price: '\u00a5146 \u2248 $20.28',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-1bb200000197910d6d570a22d249_1000_1000.jpg',
        url: 'https://kaspreadsheet.com/goods-133199.html',
        category: 'Belts',
      },
      {
        id: '133145',
        title: 'AMIRI Logo Buckle Belt White Leather with Gold Hardware',
        price: '\u00a595 \u2248 $13.19',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-482a000001952f0b7ef60aa0834c-unadjust_936_925.png',
        url: 'https://kaspreadsheet.com/goods-133145.html',
        category: 'Belts',
      },
      {
        id: '133079',
        title: 'Herm\u00e8s H-Pin Buckle Leather Belt - Multi-Color Distressed Finish',
        price: '\u00a5142 \u2248 $19.72',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-400500000195c492a20b0a23b4de_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-133079.html',
        category: 'Belts',
      },
      {
        id: '133074',
        title: 'Dior Oblique Pattern Belt with CD Buckle - Gray Black Silver Gold',
        price: '\u00a5128 \u2248 $17.78',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-0eb600000194e1e8290b0a232357_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-133074.html',
        category: 'Belts',
      },
      {
        id: '133059',
        title: 'Valentino Garavani VLogo Belt in Multiple Colors',
        price: '\u00a568 \u2248 $9.44',
        image: 'https://si.geilicdn.com/open1858585309-1234478995-07e4000001977db6177b0a8133b0_2560_3413.jpg',
        url: 'https://kaspreadsheet.com/goods-133059.html',
        category: 'Belts',
      },
      {
        id: '133045',
        title: 'Burberry Black Check-Print Leather Belt with Monogram Buckle',
        price: '\u00a585 \u2248 $11.81',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-3d6100000193b49f9e400a210298_1276_1702.jpg',
        url: 'https://kaspreadsheet.com/goods-133045.html',
        category: 'Belts',
      },
      {
        id: '133023',
        title: 'Fendi FF Logo Belt Black Leather with Gold Silver Black Buckles',
        price: '\u00a5139 \u2248 $19.31',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-191100000195c48b97cd0a231226-unadjust_500_375.gif',
        url: 'https://kaspreadsheet.com/goods-133023.html',
        category: 'Belts',
      },
      {
        id: '133021',
        title: 'Cartelostyle Geometric Pattern Leather Belt with G-Shape Buckle',
        price: '\u00a576 \u2248 $10.56',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-58e500000193d93330f30a210559-unadjust_783_842.png',
        url: 'https://kaspreadsheet.com/goods-133021.html',
        category: 'Belts',
      },
    ],
  },
  {
    key: 'perfumes',
    name: 'Perfumes',
    products: [
      {
        id: '138044',
        title: 'Delina 75ml Pink Perfume Bottle with Tassel Cap and Elegant Design',
        price: '\u00a5148 \u2248 $20.56',
        image: 'https://si.geilicdn.com/pcitem1945403796-045400000196c304bc950a239846_1199_1199.jpg',
        url: 'https://kaspreadsheet.com/goods-138044.html',
        category: 'Perfumes',
      },
      {
        id: '133255',
        title: 'Gucci Bloom Floral Print 5-Piece Mini Perfume Set with Gift Box',
        price: '\u00a5130 \u2248 $18.06',
        image: 'https://si.geilicdn.com/open1742154973-1234478995-508b00000197a7e361940aa0c791_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-133255.html',
        category: 'Perfumes',
      },
      {
        id: '133248',
        title: 'Gucci Bloom Floral Print 5-Piece Mini Perfume Set with Gift Box',
        price: '\u00a5109 \u2248 $15.14',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-121600000194c3615f810a22d234_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-133248.html',
        category: 'Perfumes',
      },
      {
        id: '133247',
        title: 'Yves Saint Laurent La Nuit de L\u2019Homme Eau de Parfum Black Bottle',
        price: '\u00a5108 \u2248 $15.00',
        image: 'https://si.geilicdn.com/open1823866485-1234478995-03e300000197841b99f20a231226_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-133247.html',
        category: 'Perfumes',
      },
      {
        id: '133207',
        title: 'Chanel Chance Eau Tendre Perfume - Pink Bottle with Gold Cap',
        price: '\u00a5108 \u2248 $15.00',
        image: 'https://si.geilicdn.com/open1648936853-1234478995-0ef200000194882a14e00a232357_1200_1200.jpg',
        url: 'https://kaspreadsheet.com/goods-133207.html',
        category: 'Perfumes',
      },
      {
        id: '133204',
        title: 'Harrods The Exclusive Collection Perfume 100ml Gold Bottle',
        price: '\u00a5159 \u2248 $22.08',
        image: 'https://si.geilicdn.com/open1623462477-1234478995-6a8d00000196f49bdc7b0a231226_1280_1280.jpg',
        url: 'https://kaspreadsheet.com/goods-133204.html',
        category: 'Perfumes',
      },
      {
        id: '133051',
        title: 'MCM Visetos Mini Bag Perfume Bottle Design Gold Logo Print',
        price: '\u00a5324 \u2248 $45.00',
        image: 'https://si.geilicdn.com/pcitem1968774131-48c200000197ede4c4dd0a23037f_1080_1080.jpg',
        url: 'https://kaspreadsheet.com/goods-133051.html',
        category: 'Perfumes',
      },
      {
        id: '133038',
        title: 'Gucci Bloom Floral Print Mini Perfume 5-Piece Gift Set',
        price: '\u00a5141 \u2248 $19.58',
        image: 'https://si.geilicdn.com/open1742154973-1234478995-508b00000197a7e361940aa0c791_800_800.jpg',
        url: 'https://kaspreadsheet.com/goods-133038.html',
        category: 'Perfumes',
      },
    ],
  },
];

export const allProducts = productCategories.flatMap((cat) => cat.products);